import { memo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISortTH from 'UIComponents/table/UISortTH';
import UITable from 'UIComponents/table/UITable';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import ContentRoutes from 'ContentUtils/Routes';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error Untyped module
import { getContent } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getHasAdvancedLandingPagesWriteScope } from 'ContentEditorUI/redux/selectors/authSelectors';
import { CrmSearchSortDirToTableSortDir } from 'ContentEditorUI/constants/contentManagement';
import { getContentStatusType } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { ContentStatus, DateCell, NameAndUrlCell } from './ContentTableCells';
import ContentActions from './ContentActions';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SortableHeader = ({
  sorts,
  columnName,
  updateSort
}) => {
  return /*#__PURE__*/_jsx(UISortTH, {
    className: "text-left",
    sort: sorts.selectedColumn === columnName ? CrmSearchSortDirToTableSortDir[sorts.sortDir] : 'none',
    role: "columnheader",
    onSortChange: () => updateSort(columnName),
    "data-test-id": `column-header-${columnName}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `contentManagementPanel.table.columns.${columnName}`
    })
  });
};
const TableHeader = ({
  sorts,
  updateSort
}) => {
  return /*#__PURE__*/_jsx("thead", {
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx(SortableHeader, {
        sorts: sorts,
        columnName: "hs_name",
        updateSort: updateSort
      }), /*#__PURE__*/_jsx(SortableHeader, {
        sorts: sorts,
        columnName: "hs_state",
        updateSort: updateSort
      }), /*#__PURE__*/_jsx(SortableHeader, {
        sorts: sorts,
        columnName: "hs_updated_at",
        updateSort: updateSort
      })]
    })
  });
};
const TableRow = /*#__PURE__*/memo(({
  content,
  hasAdvancedLandingPagesWriteScope,
  isContentCurrentlyOpenInEditor,
  openModal,
  isPinnedRow
}) => {
  const {
    name,
    updated,
    url,
    id,
    categoryId
  } = content;
  const contentStatusType = getContentStatusType(content);
  return /*#__PURE__*/_jsxs("tr", {
    "data-test-id": "table-row",
    style: isPinnedRow ? {
      background: CALYPSO_LIGHT
    } : undefined,
    children: [/*#__PURE__*/_jsx(UITableHoverCell, {
      "data-test-id": `content-hover-cell-${content.id}`,
      hoverContent: /*#__PURE__*/_jsx(ContentActions, {
        content: content,
        openModal: openModal
      }),
      children: /*#__PURE__*/_jsx(NameAndUrlCell, {
        contentName: name,
        contentUrl: url,
        editUrl: ContentRoutes.edit(id, categoryId),
        isContentCurrentlyOpenInEditor: isContentCurrentlyOpenInEditor
      })
    }), /*#__PURE__*/_jsx(ContentStatus, {
      contentStatusType: contentStatusType,
      content: content,
      hasAdvancedLandingPagesWriteScope: hasAdvancedLandingPagesWriteScope
    }), /*#__PURE__*/_jsx(DateCell, {
      contentName: name,
      cellType: "updated",
      date: updated
    })]
  });
});
const TableRows = ({
  contentData,
  openModal,
  shouldShowNowEditingTableRow
}) => {
  const currentlyOpenContentId = useSelector(getContentModelId);
  const currentlyOpenContent = useSelector(getContent);
  const hasAdvancedLandingPagesWriteScope = useSelector(getHasAdvancedLandingPagesWriteScope);
  return /*#__PURE__*/_jsxs("tbody", {
    children: [shouldShowNowEditingTableRow && /*#__PURE__*/_jsx(TableRow, {
      content: currentlyOpenContent,
      isContentCurrentlyOpenInEditor: true,
      hasAdvancedLandingPagesWriteScope: hasAdvancedLandingPagesWriteScope,
      openModal: openModal,
      isPinnedRow: true
    }, currentlyOpenContentId), contentData.map(content => /*#__PURE__*/_jsx(TableRow, {
      content: content,
      isContentCurrentlyOpenInEditor: currentlyOpenContentId === content.id,
      hasAdvancedLandingPagesWriteScope: hasAdvancedLandingPagesWriteScope,
      openModal: openModal,
      isPinnedRow: false
    }, content.id))]
  });
};
const ContentTable = ({
  data,
  openModal,
  sorts,
  updateSort,
  shouldShowNowEditingTableRow
}) => {
  return /*#__PURE__*/_jsx(UIScrollContainer, {
    style: {
      height: '100%'
    },
    children: /*#__PURE__*/_jsxs(UITable, {
      "data-test-id": "content-table",
      responsive: false,
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {
          style: {
            width: 325
          }
        }), /*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {})]
      }), /*#__PURE__*/_jsx(TableHeader, {
        sorts: sorts,
        updateSort: updateSort
      }), /*#__PURE__*/_jsx(TableRows, {
        contentData: data,
        openModal: openModal,
        shouldShowNowEditingTableRow: shouldShowNowEditingTableRow
      })]
    })
  });
};
export default ContentTable;